import {
    FaAppleAlt,
    FaBreadSlice,
    FaCoffee,
    FaCookie,
    FaFish,
    FaHamburger,
    FaIceCream,
    FaMoon,
    FaMugHot,
    FaPizzaSlice,
    FaSun,
    FaUtensils,
} from 'react-icons/fa';
import { FaBowlFood, FaBowlRice, FaGlassWater } from 'react-icons/fa6';

const DEFAULT_CATEGORY_ICON = {
    Icon: FaUtensils,
    color: '#475569',
    bg: '#e2e8f0',
};

/** Keyword rules — first match wins; keep more specific patterns above broader ones. */
const CATEGORY_ICON_RULES = [
    {
        match: (n) =>
            includesAny(n, 'drink', 'juice', 'beverage', 'shake', 'smoothie', 'milkshake', 'soda', 'lassi', 'water'),
        meta: { Icon: FaGlassWater, color: '#0369a1', bg: '#e0f2fe' },
    },
    {
        match: (n) => includesAny(n, 'coffee', 'tea', 'chai', 'hot drink'),
        meta: { Icon: FaMugHot, color: '#92400e', bg: '#fef3c7' },
    },
    {
        match: (n) => includesAny(n, 'rice', 'biryani', 'pulao', 'pulav', 'fried rice', 'dal rice'),
        meta: { Icon: FaBowlRice, color: '#b45309', bg: '#ffedd5' },
    },
    {
        match: (n) => n === 'breakfast' || includesAny(n, 'breakfast'),
        meta: { Icon: FaCoffee, color: '#b45309', bg: '#fef3c7' },
    },
    {
        match: (n) => n === 'lunch' || (includesAny(n, 'lunch') && !includesAny(n, 'brunch')),
        meta: { Icon: FaSun, color: '#0e7490', bg: '#cffafe' },
    },
    {
        match: (n) => n === 'dinner' || includesAny(n, 'dinner'),
        meta: { Icon: FaMoon, color: '#6d28d9', bg: '#ede9fe' },
    },
    {
        match: (n) => includesAny(n, 'snack', 'evening snack', 'morning snack'),
        meta: { Icon: FaCookie, color: '#c2410c', bg: '#ffedd5' },
    },
    {
        match: (n) => includesAny(n, 'burger'),
        meta: { Icon: FaHamburger, color: '#b45309', bg: '#fef3c7' },
    },
    {
        match: (n) => includesAny(n, 'pizza'),
        meta: { Icon: FaPizzaSlice, color: '#dc2626', bg: '#fee2e2' },
    },
    {
        match: (n) => includesAny(n, 'sandwich', 'bread', 'toast', 'wrap'),
        meta: { Icon: FaBreadSlice, color: '#ca8a04', bg: '#fef9c3' },
    },
    {
        match: (n) =>
            includesAny(n, 'dessert', 'sweet', 'ice cream', 'icecream', 'cake', 'pastry', 'mithai'),
        meta: { Icon: FaIceCream, color: '#db2777', bg: '#fce7f3' },
    },
    {
        match: (n) => includesAny(n, 'soup', 'curry', 'gravy', 'dal', 'sambar', 'stew'),
        meta: { Icon: FaBowlFood, color: '#c2410c', bg: '#ffedd5' },
    },
    {
        match: (n) => includesAny(n, 'salad', 'fruit'),
        meta: { Icon: FaAppleAlt, color: '#15803d', bg: '#dcfce7' },
    },
    {
        match: (n) => includesAny(n, 'fish', 'seafood', 'prawn', 'shrimp'),
        meta: { Icon: FaFish, color: '#1d4ed8', bg: '#dbeafe' },
    },
];

function includesAny(normalized, ...terms) {
    return terms.some((term) => normalized.includes(term));
}

function normalizeCategoryName(name) {
    return String(name ?? '').trim().toLowerCase();
}

export function getMenuCategoryIconMeta(categoryName) {
    const normalized = normalizeCategoryName(categoryName);
    if (!normalized) return DEFAULT_CATEGORY_ICON;

    const rule = CATEGORY_ICON_RULES.find(({ match }) => match(normalized));
    return rule ? rule.meta : DEFAULT_CATEGORY_ICON;
}
